// extracted by mini-css-extract-plugin
export default {"container":"hawk-promotion-main-container"};